import * as Long from "long";
import { selectResourceInfo } from "../../../balancingSelectors/selectBalancingResources";
import { IdResource } from "../../../constants/IdResource";
import { selectInventoryResourceInfo } from "../../../selectors/selectInventoryInfo";
export var checkHasEnoughResourceForTrade = function (path) { return function (action, state$) {
    var state = state$.value;
    var resourceInfo = selectResourceInfo(action.itemId);
    if (resourceInfo.buyValue && resourceInfo.buyValue.resourceId === IdResource.Money) {
        var ownedAmount = selectInventoryResourceInfo(state, resourceInfo.buyValue.resourceId).amount ||
            Long.ZERO;
        var requiredAmount = action.amount * resourceInfo.buyValue.amount;
        if (ownedAmount.lessThan(requiredAmount)) {
            return path;
        }
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/trade-component/checks/checkHasEnoughResourceForTrade.ts
// module id = 2450
// module chunks = 3